import React, { useCallback } from "react";
import { useSiToggle } from "../../MCS3/Schedule4D/useSiToggle";
import { patchTaskSiInList } from "../../MCS3/Schedule4D/siUtils";
import { update4D } from "./api";
import InlineGantt from "./InlineGantt";

const ScheduleComponent = ({
  rows,
  setRows,
  projectId,
  onRowClick,
  accessToken,
  onRefresh,
  includeResponsible = false,
  plantPeople = [],
  plantLeads  = [],
  resources   = [],
  onSiUpdated,
}) => {
  /* ── SI toggle ────────────────────────────────────────────────────── */
  const { handleSiChange, siUpdatingIds } = useSiToggle({
    accessToken,
    onUpdated: (taskId, si) => {
      if (setRows) setRows((prev) => patchTaskSiInList(prev, taskId, si));
      onSiUpdated?.(taskId, si);
    },
  });

  /* ── Save revised dates ───────────────────────────────────────────── */
  const handleSave = useCallback(
    async ({ id, revisedStart, revisedEnd }) => {
      await update4D(id, { revisedStart, revisedEnd }, accessToken);
      if (setRows)
        setRows((prev) =>
          prev.map((r) =>
            String(r.id) === String(id) ? { ...r, revisedStart, revisedEnd } : r,
          ),
        );
      if (onRefresh) await onRefresh();
    },
    [accessToken, setRows, onRefresh],
  );

  return (
    <InlineGantt
      rows={rows}
      onSiChange={handleSiChange}
      siUpdatingIds={siUpdatingIds}
      onRowClick={onRowClick}
    />
  );
};

export default ScheduleComponent;
